import React from 'react';
import { 
  Table as MuiTable, 
  TableContainer,
  Paper 
} from '@mui/material';

function Table({ children, sx = {}, minWidth = 'auto' }) {
  return (
    <TableContainer 
      component={Paper} 
      sx={{
        boxShadow: 'none',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '12px',
        overflowX: 'auto',
        overflowY: 'visible',
        background: '#0f172a',
        // Always show scrollbar
        '&::-webkit-scrollbar': {
          height: 10,
          display: 'block'
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#64748b',
          borderRadius: 5,
          '&:hover': {
            background: '#94a3b8'
          }
        },
        '&::-webkit-scrollbar-track': {
          background: 'rgba(0, 0, 0, 0.3)',
          borderRadius: 5
        },
        scrollbarWidth: 'thin',
        scrollbarColor: '#64748b rgba(0, 0, 0, 0.3)',
        '& .MuiTableRow-root': {
          transition: 'all 0.2s ease',
          '&:hover': {
            background: 'rgba(59, 130, 246, 0.05)'
          }
        },
        '& .MuiTableCell-root': {
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          padding: '16px',
          fontSize: '0.9rem',
          color: '#cbd5e1',
          whiteSpace: 'nowrap'
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
          borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
          paddingTop: '20px',
          paddingBottom: '20px',
          background: '#1e293b',
          color: '#e2e8f0',
          fontWeight: 700
        }
      }}
    >
      <MuiTable sx={{ minWidth, ...sx }}>
        {children}
      </MuiTable>
    </TableContainer>
  );
}

export default Table;
